/* Small seeded shuffle helpers shared by the exam and the quizzes. */
export function shuffle(a, rnd) {
  const r = a.slice();
  for (let i = r.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [r[i], r[j]] = [r[j], r[i]]; }
  return r;
}

// Small seeded generator so an attempt can be rebuilt from its seed (for autosave).
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/* A fixed shuffle of option positions for one question, the same on every visit.
   Used by module quizzes so saved answers (stored by original option number) stay valid. */
export function optionOrder(key, n) {
  let h = 2166136261;
  for (let k = 0; k < key.length; k++) { h ^= key.charCodeAt(k); h = Math.imul(h, 16777619); }
  return shuffle(Array.from({ length: n }, (_, k) => k), mulberry32(h >>> 0));
}

